import type { SxProps, Theme } from '@mui/material/styles';

export const CAMERA_TOOLBAR_ICON_BUTTON_SX: SxProps<Theme> = {
  p: 0,
  width: 28,
  height: 28,
  color: 'common.white',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .MuiSvgIcon-root': {
    fontSize: 18,
    lineHeight: 0,
    display: 'block',
  },
  '&.Mui-disabled': {
    color: 'common.white',
    opacity: 0.35,
  },
};
